export const CircleIcon = ({ className }: { className: string }) => {
  return (
    <svg className={className} fill="none" viewBox="0 0 238 238" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M118.306 15.0117C65.3391 15.0117 21.6914 54.9145 15.7852 106.299C15.9605 109.119 16.9711 111.968 20.3428 111.968C39.9901 111.968 154.096 111.968 214.549 111.968C219.594 111.968 220.65 108.435 220.806 106.145C214.83 54.8349 171.219 15.0119 118.306 15.0117Z"
        fill="#810693"
      />

      <path
        d="M118.578 0C184.067 0 237.157 53.0892 237.157 118.578C237.157 184.067 184.067 237.157 118.578 237.157C53.0892 237.157 0 184.067 0 118.578C0.000173178 53.0893 53.0893 0.000173223 118.578 0ZM118.306 15.0117C65.3391 15.0117 21.6914 54.9145 15.7852 106.299C15.9605 109.119 16.9711 111.968 20.3428 111.968C39.9901 111.968 154.096 111.968 214.549 111.968C219.594 111.968 220.65 108.435 220.806 106.145C214.83 54.8349 171.219 15.0119 118.306 15.0117Z"
        fill="#FF0ECA"
      />
    </svg>
  );
};
